module.exports = __webpack_public_path__ + "img/01.0549df60.webp";